// extracted by mini-css-extract-plugin
export var assigneeBadge = "_j4-0";
export var assigneeDetails = "_j4-1";
export var assigneeInfo = "_j4-2";
export var dropdownContainer = "_j4-4";
export var dropdownImage = "_j4-5";
export var editAssigneeInfo = "_j4-3";
export var editAssigneeModalContainer = "_j4-6";
export var hidden = "_j4-8";
export var input = "_j4-7";